import {
    type IsoAndUnixTimestamp,
    isoAndUnixZodSchema,
} from "@@/shared/date-time/iso-and-unix";
import {
    type DurationInMinutes,
    durationInMinutesZodSchema,
} from "@@/shared/date-time/time-spans";
import { z } from "zod";
import { type ProviderId, providerIdZodSchema } from "../provider-id";

type ProviderOverridePreptimeCommand = {
    _type: "PROVIDER_OVERRIDE_PREPTIME";
    providerId: ProviderId;
    prepTime: DurationInMinutes;
    until: IsoAndUnixTimestamp;
};

const providerOverridePreptimeCommandZodSchema: z.ZodSchema<ProviderOverridePreptimeCommand> =
    z.object({
        _type: z.literal("PROVIDER_OVERRIDE_PREPTIME"),
        providerId: providerIdZodSchema,
        prepTime: durationInMinutesZodSchema,
        until: isoAndUnixZodSchema,
    });

export { providerOverridePreptimeCommandZodSchema };
export type { ProviderOverridePreptimeCommand };
